import Repository from '../axios'

export default {
  fetchReportTemplates(filterQuery = '') {
    return Repository.get(`/reportTemplate/list?${filterQuery}`)
  },
  updateReportTemplate(id, payload) {
    return Repository.put(`/reportTemplate/${id}/update`, payload)
  },
  uploadAttachment(id, file) {
    return Repository.post(`/reportTemplate/${id}/attachments`, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
};
